<template>
    <div class="error-holder">
        <h1>4<span>0</span>4</h1>
    </div>
</template>
<script>
export default {
	mounted() {
		this.$store.dispatch('actionPreloader', false);
	},
};
</script>
<style lang="scss" scoped>
    @import 'error';
</style>
